import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { api, fmtErr } from "@/lib/api";
import { Brand } from "@/components/Brand";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Brand /></div>
        <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm p-6 sm:p-8" data-testid="forgot-password-card">
          {done ? (
            <div className="text-center py-4" data-testid="forgot-success">
              <MailCheck className="w-12 h-12 text-green-600 mx-auto" />
              <h1 className="mt-4 text-xl font-bold font-heading text-slate-900">Check your inbox</h1>
              <p className="mt-2 text-sm text-slate-600">If an account exists for <strong>{email}</strong>, a password reset link has been generated.</p>
              <Link to="/login" data-testid="forgot-back-login" className="mt-6 inline-block text-sm font-semibold text-blue-700">Back to login</Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold font-heading text-slate-900">Forgot password</h1>
              <p className="mt-1.5 text-sm text-slate-600">Enter your account email and we'll generate a reset link.</p>
              {error && <div data-testid="forgot-error" className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-3">{error}</div>}
              <form onSubmit={submit} className="mt-6 space-y-4">
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full rounded-xl border border-slate-300 px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="you@example.com" />
                <button type="submit" data-testid="forgot-submit-btn" disabled={loading}
                  className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl font-semibold text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-60 transition-colors">
                  {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send Reset Link
                </button>
              </form>
              <p className="mt-6 text-center text-sm text-slate-600"><Link to="/login" className="font-semibold text-blue-700">Back to login</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
